import { useState, useEffect } from 'react';
import { PackageSlide } from '../../../../models/slides/PackageSlide';

interface UseInitPackageDataProps {
  slides: PackageSlide[];
  currentIndex: number;
}

export const useInitPackageData = ({ slides, currentIndex }: UseInitPackageDataProps) => {
  const [packageData, setPackageData] = useState({} as PackageSlide);

  useEffect(() => {
    if (!slides || !slides[currentIndex]) return;
    setPackageData(slides[currentIndex]);
  }, [slides && slides[currentIndex]]);

  return { packageData };
};
